import { Image as DatoImage } from "react-datocms";
import { ImageType } from "@/types";
import { AnchorButton } from "@narrative-software/narrative-web-ui";

type SimpleHeroProps = {
  title: string;
  subtitle: string;
  heroBackgroundImage: ImageType;
  ctaText: string;
  ctaHref: string;
};

const SimpleHero: React.FC<SimpleHeroProps> = ({ title, subtitle, heroBackgroundImage, ctaText, ctaHref }) => {
  return (
    <section className="w-full bg-mankey text-white text-center">
      <div className="py-20 md:py-26 w-full relative px-4">
        <DatoImage data={heroBackgroundImage.responsiveImage} layout="fill" />
        <div className="relative w-full max-w-[998px] mx-auto">
          <h1 className="text-40 md:text-48 font-semibold mb-2">{title}</h1>
          <p className="text-18">{subtitle}</p>
          <AnchorButton colour="white" className="md:max-w-[380px] mx-auto mt-5" appearance="primary" href={ctaHref}>
            {ctaText}
          </AnchorButton>
        </div>
      </div>
    </section>
  );
};

export { SimpleHero };
